var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTz = function SvgTz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M3.514 20.486c.504.503 1.041.952 1.604 1.347L21.833 5.12a12.068 12.068 0 0 0-2.952-2.952L2.167 18.882c.395.563.844 1.1 1.347 1.604Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M3.514 3.514C-.27 7.3-.998 12.985 1.332 17.5l16.17-16.169C12.986-.998 7.3-.272 3.514 3.514Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#338AF3",
    d: "M20.485 20.485c3.786-3.786 4.513-9.471 2.182-13.987L6.498 22.667c4.516 2.33 10.202 1.604 13.987-2.182Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTz;